import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { SvgProps } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import type { AppColors } from '@squire/ui';

export interface PhoneIconProps extends SvgProps {
  size?: number;
  color?: keyof AppColors;
}

export const PhoneIcon: React.FC<PhoneIconProps> = ({
  size = 24,
  color = 'iconPrimary',
  ...props
}) => {
  const { theme: colors } = useUnistyles();
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <Path
        d="M22 16.92V19.92C22.0011 20.1985 21.9441 20.4742 21.8325 20.7292C21.7209 20.9842 21.5573 21.2126 21.3522 21.3992C21.1472 21.5857 20.9053 21.7262 20.6419 21.8117C20.3785 21.8972 20.0995 21.9257 19.82 21.895C16.7428 21.5856 13.787 20.5341 11.19 18.82C8.77382 17.3148 6.72533 15.2663 5.22 12.85C3.49996 10.2412 2.44824 7.27099 2.15 4.18C2.11933 3.90071 2.14784 3.62178 2.23337 3.35849C2.3189 3.0952 2.45925 2.85326 2.64569 2.64817C2.83213 2.44308 3.06065 2.27933 3.3157 2.16761C3.57074 2.05589 3.84649 1.99874 4.125 2H7.125C7.62156 1.99522 8.10777 2.16708 8.50206 2.48761C8.89635 2.80814 9.17493 3.25887 9.295 3.77C9.59283 4.95479 10.0537 6.09045 10.66 7.14C10.8858 7.52469 11.0012 7.96604 10.995 8.415C10.9888 8.86396 10.8612 9.30219 10.625 9.68L9.125 11.18C10.6864 13.7375 12.7625 15.8136 15.32 17.375L16.82 15.875C17.1978 15.6388 17.636 15.5112 18.085 15.505C18.534 15.4988 18.9753 15.6142 19.36 15.84C20.4095 16.4463 21.5452 16.9072 22.73 17.205C23.2411 17.3251 23.6919 17.6036 24.0124 17.9979C24.3329 18.3922 24.5048 18.8784 24.5 19.375L22 16.92Z"
        stroke={colors[color]}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

PhoneIcon.displayName = 'PhoneIcon';
